import React, { useCallback, useContext, useEffect, useState } from "react";
import { ACTIONS } from "../../../../constants/Constants";
import { t, use } from "i18next";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import {
  Checkbox,
  ComboBox,
  DirectionalHint,
  Dropdown,
  SelectableOptionMenuItemType,
  TooltipDelay,
  TooltipHost,
} from "@fluentui/react";
import { ClearIcon } from "@fluentui/react-icons-mdl2";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";


const ConfigureRadiologistAccess = (props) => {
  const [radiologistCheckBoxClick, setRadiologistCheckBoxClick] = useState([]);
  const [selectedModality, setSelectedModality] = useState(
    props.values.radiologistIdList.map((r) => r.modalityIds)
  );
  const [modalityList, setModalityList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const {themeName}=useContext(themeContext);

  useEffect(() => {
    let mdl = props.modalityList.map((m) => {
      return {
        key: m.id,
        text: m.name,
      };
    });
    setModalityList(mdl);
  }, []);

  const dropDownStyle = {
    dropdown: {
      width: "100%",
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "300px",
      overflowY: 'auto',
      colorScheme:`${themeName==='light'?'none':'inherit'}`  
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white",
    },
  };
  

  // useEffect(() => {
  //   setSelectedModality(
  //     props.values.radiologistIdList.map((r) => r.modalityIds)
  //   );
  // }, []);

  useEffect(() => {
    let checkboxClick = props.values.radiologistIdList.map((r) => {
      return r.modalityIds.length != 0;
    });
    setRadiologistCheckBoxClick((prev) => [...prev, ...checkboxClick]);
  }, []);

  const getModalityNames = (modalityIds) => {
    let modalityNames = [];
    modalityNames = props.modalityList
      .filter((m) => modalityIds.includes(m.id))
      .map((modality) => modality.name);
    return modalityNames.length === 0 ? "-" : modalityNames.join(", ");
  };

  useEffect(() => {
    props.values.radiologistIdList.map((r, index) => {
      r.modalityIds = selectedModality[index];
    });
  }, [selectedModality]);

  const handleAllRadiologistCheckBoxClick = useCallback((e, isChecked) => {
    props.setCheckAllRadiologist(!props.checkAllRadiologist);
    var modalityIdList = props.modalityList.map((mod) => mod.id);
    props.radiologistList
      .filter((rad) => !props.selectedRadiologistMap.has(rad.id))
      .map((rad) => {
        props.setSelectedRadiologistMap((prevMap) => {
          const nextMap = new Map(prevMap);
          nextMap.set(rad.id, modalityIdList);
          return nextMap;
        });
      });

    if (props.checkAllRadiologist) {
      props.setSelectedRadiologistMap(new Map());
    }
    props.setTabStatusInitialValue(() => {
      const newStatus = { ...props.tabStatusInitialValue };
      newStatus.tab11Status =
        isChecked == true
          ? { value: "Completed", color: "green" }
          : { value: "Info", color: "red" };
      return newStatus;
    });
  });

  const handleRadiologistCheckBoxClick = useCallback(
    (e, isChecked, selection) => {
      if (props.selectedRadiologistMap.has(e) && selection.key == 0) {
        //To handle deselection of firm
        props.setSelectedRadiologistMap((prevMap) => {
          const nextMap = new Map(prevMap);
          nextMap.delete(e);
          return nextMap;
        });
        props.setCheckAllRadiologist(false);
      } else {
        // To handle Selection of firm
        var modalityIdList = modalityList.map((mod) => mod.key);
        if (selection.key != 0) {
          // To handle Modality selection
          modalityIdList = props.selectedRadiologistMap.get(e);
          modalityIdList = modalityIdList.filter((mod) => mod != selection.key);
          if (
            selection.selected === true &&
            modalityIdList.indexOf(selection.key) === -1
          ) {
            modalityIdList.push(selection.key); //  To handle modality selection
          }
        }
        props.setSelectedRadiologistMap((prevMap) => {
          const nextMap = new Map(prevMap);
          nextMap.set(e, modalityIdList);
          return nextMap;
        });
      }

      props.setTabStatusInitialValue(() => {
        const newStatus = { ...props.tabStatusInitialValue };
        if (isChecked == true) {
          newStatus.tab11Status = { value: "Completed", color: "green" };
        }
        return newStatus;
      });
    }
  );

  const handleClearButton = useCallback((radId) => {
    if (props.selectedRadiologistMap.has(radId)) {
      let modalityIdList = [];
      props.setSelectedRadiologistMap((prevMap) => {
        const nextMap = new Map(prevMap);
        nextMap.set(radId, modalityIdList);
        return nextMap;
      });
    }
  });

  return (
    <>
      <div className="tab-section">
        {props.action === ACTIONS.EDIT && (
          <>
            <section className="sectionA">
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  padding: "0px 0px",
                  marginBottom: "20px"
                }}
              >
                Radiologists
              </p>
            </section>

            {/* SELECT ALL  */}
            {props.radiologistList.length > 0 && (
              <div className="ms-Grid-row" dir="ltr">
                <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                  <Checkbox
                    label="Select All"
                    onChange={handleAllRadiologistCheckBoxClick}
                    id="all"
                    checked={props.checkAllRadiologist == true}
                  />
                </div>
              </div>
            )}
            <div className="ms-Grid-row" dir="ltr">
              {props.radiologistList.map((rad, index) => {
                return (
                  <div
                    key={index}
                    className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4"
                  >
                    <div
                      className="ms-sm12 ms-md8 ms-lg6 ms-xl10"
                      style={{
                        display: "block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Checkbox
                        key={rad.id}
                        label={rad.username}
                        name={rad.username}
                        onChange={(e, isChecked) =>
                          handleRadiologistCheckBoxClick(+rad.id, isChecked, {
                            key: 0,
                          })
                        }
                        //checked={props.checkFirm.includes(firm.id)}
                        checked={props.selectedRadiologistMap.has(rad.id)}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10">
                        <Dropdown
                          styles={dropDownStyle}
                          placeholder="Select Modality"
                          multiSelect
                          selectedKeys={
                            props.selectedRadiologistMap.get(+rad.id) || []
                          }
                          options={modalityList}
                          disabled={!props.selectedRadiologistMap.has(+rad.id)}
                          onChange={(e, selection) =>
                            handleRadiologistCheckBoxClick(
                              +rad.id,
                              true,
                              selection
                            )
                          }
                          // errorMessage={props.errors.modalityIdList}
                        />
                      </div>
                      <div
                        className="ms-sm12 ms-md8 ms-lg6 ms-xl2 cursor-pointer"
                        onClick={() => handleClearButton(+rad.id)}
                        style={{ paddingLeft: "5px" }}
                      >
                        <CustomToolTipHost content="Clear" id={"tooltip_" + rad.id}>
                          <ClearIcon></ClearIcon>
                        </CustomToolTipHost>
                      </div>
                      {/* <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2">
                      <p>select all</p>
                    </div> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {props.action === ACTIONS.VIEW && (
          <>
            <section className="sectionA">
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  padding: "0px 0px",
                  marginBottom: "20px",
                }}
              >
                Radiologists
              </p>
            </section>

            {props.selectedRadiologistMap.size == 0 && (
              <>
                {" "}
                <span>No Radiologist configured</span>
              </>
            )}

            <div className="ms-Grid" dir="ltr">
              {props.radiologistList.map((rad) => {
                return (
                  <>
                    {!!props.selectedRadiologistMap.has(rad.id) && (
                      <div className="ms-Grid-row" dir="ltr">
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg3 ms-xl3">
                          <span style={{wordBreak:"break-word"}}>{rad.username}</span>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4 firm-access-modality-names">
                          <CustomToolTipHost
                            content={getModalityNames(
                              props.selectedRadiologistMap.get(rad.id)
                            )}
                            id={"tooltip_" + rad.id}
                          >
                            {getModalityNames(
                              props.selectedRadiologistMap.get(rad.id)
                            )}
                          </CustomToolTipHost>
                        </div>
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ConfigureRadiologistAccess;
